import "./PlayerCard.css";
import "../../Skeleton/SkeletonLoader.css";
import { connect } from "react-redux";
import React from "react";
import axios from "axios";
import {
  setPlayerCounts,
  setMainPageView,
  setDisplayPlayers,
  goBackBoolean,
  setTeamNameOfSelectedPlayer,
  setGameTeams,
  setAPIFlag,
} from "../../../redux";
import {
  PLAYER_STATUSES,
  api_url,
  token,
} from "../../../utils/constantInformation";

import SkeletonLoader from "../../Skeleton/SkeletonLoader";
import { findSportByLeague, getUserJwtToken } from "../../../utils/utils";
import { API_CONSTANTS } from "../../../utils/constantInformation";

import {
  setIsResetClicked,
  setLeague,
  setPlayerExcludedCount,
  setPlayerFavouriteCount,
  setPlayerLFDCount,
  setPlayerLockedCount,
  setSortType,
} from "../../../redux/GameInformation/GameInformationAction";
import SingleCardComponent from "./SingleCard/SingleCard";

import AppCSS from "../../../assets/app/AppCSS";
import AppJS from "../../../assets/app/AppJS";
import {
  getExcludedPlayerForSlate,
  getLockedPlayerForSlate,
} from "../../../firestoreQueries";
import { getID } from "../../../firebase";
import { getStatsColumnMapping } from "../../../utils/columnsJsonInformation";

const PlayerCard = React.memo((props) => {
  const [player_detail, showPlayerDetail] = React.useState(
    props.game_information.gameInformationReducer.display_players
  );
  const [displayedPlayers, setDisplayPlayers] = React.useState(
    props.game_information.gameInformationReducer.display_players
  );

  const [gotApiData, setApiData] = React.useState(
    props.game_information.gameInformationReducer.got_api_data
  );

  const [loading, setLoading] = React.useState(props.loading);
  function getGameTeams(res) {
    console.log("first display player", res[0]);
    const team = res[0].Team;
    const team_full_name = res[0].TeamFullName;
    const opponent = res[0].Opponent;
    const opponent_full_name = res[0].OpponentFullName;
    console.log("Team", team, "Opponent", opponent);
    return [
      {
        abbr: team,
        full_name: team_full_name,
      },
      {
        abbr: opponent,
        full_name: opponent_full_name,
      },
    ];
  }
  const prev_is_reset_clicked_value = React.useRef();
  React.useEffect(async () => {
    console.log("*** PlayerCard First UseEffect Called ***");
    prev_is_reset_clicked_value.current =
      props.game_information.gameInformationReducer.is_reset_clicked;
    console.log("PlayerCard UseRef", prev_is_reset_clicked_value.current);
    props.view_setter("default_page");
    if (props.game_information.gameInformationReducer.sports) {
      if (
        props.game_information.gameInformationReducer.go_back_boolean == false
      ) {
        setLoading(true);
        setDisplayPlayers([]);
        const slate_id = props.game_information.gameInformationReducer.slate_id;
        // const game_id = slate_id.slice(0, slate_id.length - 2);
        const league = props.game_information.gameInformationReducer.sports;
        let statsColumnList = [];
        try{
          statsColumnList = getStatsColumnMapping(league, props.remoteConfig)
        }
        catch(e){
        }
        if (league !== undefined && league !== null) {

          let player_sort_type_and_order = { sort_name: "Dream11ProjectedFantasyPoints", sort_order: "DESC" };
          props.set_default_sorting_option(player_sort_type_and_order)
          const sport = findSportByLeague(
            league,
            props.remoteConfig,
            "Player Card useEffect"
          );
          const link =
            api_url +
            sport +
            "/" +
            // "/ipl/projections/" +
            encodeURIComponent(
              props.game_information.gameInformationReducer.sports
            ) +
            "/projections/" +
            encodeURIComponent(slate_id) +
            "/all";
          console.log(
            "Player Card Link",
            props.game_information.gameInformationReducer.sports,
            link
          );
          console.log("league in player card", league);

          const returnLineupInitializer = (player) => {
            player["locked"] = false;
            player["favourite"] = false;
            player["deleted"] = false;
            player["owner"] = null;
            return player;
          };

          const jwtToken = await getUserJwtToken();

          const result = await axios
            .get(
              api_url +
                sport.toLowerCase() +
                "/" +
                encodeURIComponent(
                  props.game_information.gameInformationReducer.sports
                ) +
                "/projections/" +
                encodeURIComponent(slate_id) +
                "/all",
              {
                headers: {
                  "Authorization": jwtToken
                },
              }
            )
            .then((res) => {
              console.log("API Result");
              console.log(res.data);

              return res.data;
            });
          const teams = getGameTeams(result);
          props.set_got_api_data(true);
          setApiData(true);
          props.set_game_teams(teams);
          let locked_count = 0;
          let favourite_count = 0;
          let excluded_count = 0;

          //TODO: @RTailor:: Think of optimizing this piece of code

          const startTime = new Date();
          const userID = getID();
          const lockedPlayers = await getLockedPlayerForSlate(userID, slate_id);
          const excludedPlayers = await getExcludedPlayerForSlate(
            userID,
            slate_id
          );
          console.log("Locked Players", lockedPlayers);
          console.log("Excluded Players", excludedPlayers);
          const inter_result = result.map((player) =>
            returnLineupInitializer(player)
          );
          const endTime = new Date();
          console.log(
            "[XXX] It Took...",
            endTime,
            startTime,
            endTime - startTime
          );
          // let final_result = inter_result;
          let final_result = inter_result.map((obj) => {
            console.log("DP API", obj);
            let toUpdate = {
              locked: false,
              excluded: false,
            };
            lockedPlayers.forEach((doc) => {
              console.log("locked doc", doc.data());
              let data = doc.data();
              if (data["playerID"] == obj.PlayerID) {
                toUpdate["locked"] = true;
                locked_count += 1;
              }
            });
            excludedPlayers.forEach((doc) => {
              console.log("excluded doc", doc.data());
              let data = doc.data();
              if (data["playerID"] == obj.PlayerID) {
                toUpdate["deleted"] = true;
                excluded_count += 1;
              }
            });
            let toUpdateLFD = {
              locked: locked_count,
              favourite: favourite_count,
              excluded: excluded_count,
            };
            console.log(
              "toUpdateLFD: ",
              locked_count,
              excluded_count,
              toUpdateLFD
            );

            props.update_slate_lfd_count(toUpdateLFD);
            props.update_slate_locked_count(locked_count);
            props.update_slate_favourite_count(favourite_count);
            props.update_slate_excluded_count(excluded_count);
            console.log("toUpdate: ", toUpdate);
            return { ...obj, ...toUpdate };
          });

          console.log("DP API:: ", "final", final_result);
          let non_excluded_players = final_result.filter(
            (player) => player["deleted"] === false
          );
          console.log("DP API:: ", "non excluded", non_excluded_players.length);
          showPlayerDetail(non_excluded_players);
          let sorted_result = non_excluded_players.sort(
            sortByProperty(
              props.game_information.gameInformationReducer.player_sort_type,
              statsColumnList,
              true
            )
          );
          console.log("Sorted Result", sorted_result);
          setDisplayPlayers(sorted_result);
          // console.log(sorted_result);
          props.display_players(sorted_result);
          setLoading(false);
        }
      }
    }

    props.go_back_boolean(false);
    // }
  }, [
    props.game_information.gameInformationReducer.platform,
    props.game_information.gameInformationReducer.slate_id,
    props.game_information.gameInformationReducer.is_reset_clicked,
  ]);
  React.useEffect(async () => {
    console.log("*** PlayerCard UseEffect Called ***");
    // Compare OperatorMatchInfo and toFilterPlayerStatus
    const league = props.game_information.gameInformationReducer.sports;
    let statsColumnList = [];
    try{
      statsColumnList = getStatsColumnMapping(league, props.remoteConfig)
    }
    catch(e){
    }
    const toFilterPlayerString =
      props.game_information.gameInformationReducer.player_searched_name.toLowerCase();
    const toFilterPlayerStatus =
      props.game_information.gameInformationReducer.player_status;
    console.log(
      "PC:: To Filter Player String" +
        toFilterPlayerString +
        "PC:: To Filter Player Status" +
        toFilterPlayerStatus
    );
    if (
      props.game_information.gameInformationReducer.player_position_filter !=
      "ALL"
    ) {
      const player_selected = player_detail.filter((el) => {
        if (el.deleted === false) {
          if (
            props.game_information.gameInformationReducer.filtered_team ==
            "Both"
          ) {
            if (
              props.game_information.gameInformationReducer.player_status ===
              API_CONSTANTS.NULL_CONSTANT
            ) {
              return (
                el.Position ==
                  props.game_information.gameInformationReducer
                    .player_position_filter &&
                el.OperatorPlayerName.toLowerCase().includes(
                  toFilterPlayerString
                )
              );
            } else {
              return (
                el.Position ==
                  props.game_information.gameInformationReducer
                    .player_position_filter &&
                el.OperatorPlayerName.toLowerCase().includes(
                  toFilterPlayerString
                ) &&
                el.OperatorMatchInfo !== API_CONSTANTS.NULL_CONSTANT &&
                PLAYER_STATUSES.includes(el.OperatorMatchInfo)
              );
            }
          } else {
            if (
              props.game_information.gameInformationReducer.player_status ===
              API_CONSTANTS.NULL_CONSTANT
            ) {
              return (
                el.Position ==
                  props.game_information.gameInformationReducer
                    .player_position_filter &&
                el.Team ==
                  props.game_information.gameInformationReducer.filtered_team &&
                el.OperatorPlayerName.toLowerCase().includes(
                  toFilterPlayerString
                )
              );
            } else {
              return (
                el.Position ==
                  props.game_information.gameInformationReducer
                    .player_position_filter &&
                el.Team ==
                  props.game_information.gameInformationReducer.filtered_team &&
                el.OperatorPlayerName.toLowerCase().includes(
                  toFilterPlayerString
                ) &&
                el.OperatorMatchInfo !== API_CONSTANTS.NULL_CONSTANT &&
                PLAYER_STATUSES.includes(el.OperatorMatchInfo)
              );
            }
          }
        }
      });

      console.log("================= PLAYER SELECTED ============");
      console.log(player_selected, player_selected.length);

      if (
        props.game_information.gameInformationReducer.player_sort_order == "ASC"
      ) {
        setDisplayPlayers(
          player_selected.sort(
            sortByProperty(
              props.game_information.gameInformationReducer.player_sort_type,
              statsColumnList,
              false
            )
          )
        );
      } else {
        setDisplayPlayers(
          player_selected.sort(
            sortByProperty(
              props.game_information.gameInformationReducer.player_sort_type,
              statsColumnList,
              true
            )
          )
        );
      }
      console.log(
        " props updating player count on Player Card UseEffect",
        player_selected.length
      );
      props.player_counts(player_selected.length);
    } else {
      console.log("============= Player Card position = 'ALL' ==============");
      const player_selected = player_detail.filter(
        (el) => el.deleted === false
      );
      if (
        props.game_information.gameInformationReducer.player_sort_order == "ASC"
      ) {
        setDisplayPlayers(
          player_selected.sort(
            sortByProperty(
              props.game_information.gameInformationReducer.player_sort_type,
              statsColumnList,
              false
            )
          )
        );
      } else {
        setDisplayPlayers(
          player_selected.sort(
            sortByProperty(
              props.game_information.gameInformationReducer.player_sort_type,
              statsColumnList,
              true
            )
          )
        );
      }
      console.log(" props updating player count on Player Card UseEffect 2");

      console.log(" props updating player count on Player Card UseEffect 2");
      const new_all_position_count = player_selected.filter((el) => {
        if (
          props.game_information.gameInformationReducer.filtered_team == "Both"
        ) {
          if (toFilterPlayerString.length > 0) {
            if (toFilterPlayerStatus === API_CONSTANTS.NULL_CONSTANT) {
              return (
                el.OperatorPlayerName.toLowerCase().includes(
                  toFilterPlayerString
                ) && el.deleted === false
              );
            } else {
              return (
                el.OperatorPlayerName.toLowerCase().includes(
                  toFilterPlayerString
                ) &&
                el.OperatorMatchInfo !== API_CONSTANTS.NULL_CONSTANT &&
                el.deleted === false &&
                PLAYER_STATUSES.includes(el.OperatorMatchInfo)
              );
            }
          } else {
            if (
              toFilterPlayerStatus === API_CONSTANTS.NULL_CONSTANT &&
              el.deleted === false
            ) {
              return el;
            } else {
              return (
                el.OperatorMatchInfo !== API_CONSTANTS.NULL_CONSTANT &&
                el.deleted === false &&
                PLAYER_STATUSES.includes(el.OperatorMatchInfo)
              );
            }
          }
        } else {
          if (toFilterPlayerString.length > 0) {
            if (toFilterPlayerStatus === API_CONSTANTS.NULL_CONSTANT) {
              return (
                el.OperatorPlayerName.toLowerCase().includes(
                  toFilterPlayerString
                ) &&
                el.Team ==
                  props.game_information.gameInformationReducer.filtered_team &&
                el.deleted === false
              );
            } else {
              return (
                el.OperatorPlayerName.toLowerCase().includes(
                  toFilterPlayerString
                ) &&
                el.Team ==
                  props.game_information.gameInformationReducer.filtered_team &&
                el.OperatorMatchInfo !== API_CONSTANTS.NULL_CONSTANT &&
                el.deleted === false &&
                PLAYER_STATUSES.includes(el.OperatorMatchInfo)
              );
            }
          } else {
            if (toFilterPlayerStatus === API_CONSTANTS.NULL_CONSTANT) {
              return (
                el.Team ==
                  props.game_information.gameInformationReducer.filtered_team &&
                el.deleted === false
              );
            } else {
              return (
                el.Team ==
                  props.game_information.gameInformationReducer.filtered_team &&
                el.OperatorMatchInfo !== API_CONSTANTS.NULL_CONSTANT &&
                el.deleted === false &&
                PLAYER_STATUSES.includes(el.OperatorMatchInfo)
              );
            }
          }
        }
      }).length;
      props.player_counts(new_all_position_count);
    }
  }, [
    props.game_information.gameInformationReducer.player_position_filter,
    props.game_information.gameInformationReducer.player_sort_type,
    props.game_information.gameInformationReducer.player_sort_order,
    props.game_information.gameInformationReducer.filtered_team,
    props.game_information.gameInformationReducer.game_teams,
    props.game_information.gameInformationReducer.player_searched_name,
    props.game_information.gameInformationReducer.game_teams,
    props.game_information.gameInformationReducer.player_status,
    player_detail,
  ]);

  function smartSort(statsColumnList) {
    return function (a, b) {
      for (let columnStat of statsColumnList) {
        const aValue = parseFloat(a[columnStat["actual_name"]]);
        const bValue = parseFloat(b[columnStat["actual_name"]]);

        let comparison = 0;
        if (aValue === API_CONSTANTS.NUMERIC_CONSTANT) comparison = 1;
        else if (bValue === API_CONSTANTS.NUMERIC_CONSTANT) comparison = -1;
        else if (aValue > bValue){
          comparison = -1;
          if (columnStat['desc_sort_order'] !== true) {
            comparison *= -1;
          }  
        } 
        else if (aValue < bValue){
          comparison = 1;
          if (columnStat['desc_sort_order'] !== true) {
            comparison *= -1;
          }
        }
  
        // If values are not equal, return comparison
        if (comparison !== 0) return comparison;
      }
  
      // If all criteria are equal, return 0
      return 0;
    };
  }
  

  function sortByProperty(property, statsColumnList, is_order_desc) {

    let index = statsColumnList.findIndex(stat => stat["actual_name"] == property);

    let smartSortList;
    if (index !== -1) {
      smartSortList = [
        {
          "actual_name": property,
          "desc_sort_order": is_order_desc
        },
        ...statsColumnList.slice(index + 1).map(item => ({
          "actual_name": item["actual_name"],
          "desc_sort_order": item["desc_sort_order"]
        }))
      ];
    }
    else{
      smartSortList = [
        {
          "actual_name": property,
          "desc_sort_order": is_order_desc
        }
      ]
    }

    return smartSort(smartSortList);
  }

  function renderPlayerCardsOrSkeleton() {
    const filteredPlayers = filterDisplayedPlayers();

    if (filteredPlayers.length > 0) {
      return (
        <div>
          {filteredPlayers.map((player_info, index) => (
            <SingleCardComponent
              key={player_info.OperatorPlayerID}
              index={index}
              player_info={player_info}
              show_lock_exclude={true}
            />
          ))}
        </div>
      );
    } else {
      return <SkeletonLoader className="w-100" number_of_cards={6} />;
    }
  }

  const filterDisplayedPlayers = () => {
    const { gameInformationReducer } = props.game_information;
    const { player_searched_name, player_status, filtered_team } =
      gameInformationReducer;
    const searchQuery = player_searched_name.toLowerCase();

    return displayedPlayers.filter((player) => {
      const playerMatchesSearchQuery =
        player.OperatorPlayerName.toLowerCase().includes(searchQuery);
      const playerMatchesTeam =
        filtered_team === "Both" || player.Team === filtered_team;
      const playerStatusMatches =
        player_status === API_CONSTANTS.NULL_CONSTANT ||
        (PLAYER_STATUSES.includes(player.OperatorMatchInfo) &&
          player_status !== API_CONSTANTS.NULL_CONSTANT);
      const playerNotDeleted = !player.deleted;

      return (
        playerMatchesSearchQuery &&
        playerMatchesTeam &&
        playerStatusMatches &&
        playerNotDeleted
      );
    });
  };

  function renderNoMatchTodayOrSkeleton() {
    if (props.no_match_today) {
      return (
        <div className="bg-dark text-secondary text-center d-flex justify-content-center align-items-center font-weight-bold m-2 p-2">
          <h1>No Match Today</h1>
        </div>
      );
    } else {
      return <SkeletonLoader className="w-100" number_of_cards={6} />;
    }
  }

  return (
    <>
      <AppJS />
      <AppCSS />
      <div className="playerCard__main">
        {loading ? (
          <SkeletonLoader className="w-100" number_of_cards={6} />
        ) : gotApiData ? (
          renderPlayerCardsOrSkeleton()
        ) : (
          renderNoMatchTodayOrSkeleton()
        )}
      </div>
    </>
  );
});

const mapStateToProps = (state) => {
  // console.log("YAKSHIT IS HERE", state)
  return {
    game_information: state,
    no_match_today: state.gameInformationReducer.no_match_today,
    state_slate_lfd_count: state.gameInformationReducer.slate_lfd_count,
    state_slate_locked_player_count:
      state.gameInformationReducer.slate_locked_player_count,
    state_slate_favourite_count:
      state.gameInformationReducer.slate_favourite_player_count,
    state_slate_excluded_count:
      state.gameInformationReducer.slate_excluded_player_count,
    remoteConfig: state.rcReducer,
    loading: state.gameInformationReducer.loading,
    error: state.gameInformationReducer.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    player_counts: (value) => dispatch(setPlayerCounts(value)),
    view_setter: (value) => dispatch(setMainPageView(value)),
    display_players: (value) => dispatch(setDisplayPlayers(value)),
    go_back_boolean: (value) => dispatch(goBackBoolean(value)),
    teamname_setter: (value) => dispatch(setTeamNameOfSelectedPlayer(value)),
    set_game_teams: (value) => dispatch(setGameTeams(value)),
    set_got_api_data: (value) => dispatch(setAPIFlag(value)),
    update_slate_lfd_count: (value) => dispatch(setPlayerLFDCount(value)),
    update_slate_locked_count: (value) => dispatch(setPlayerLockedCount(value)),
    update_slate_favourite_count: (value) =>
      dispatch(setPlayerFavouriteCount(value)),
    update_slate_excluded_count: (value) =>
      dispatch(setPlayerExcludedCount(value)),
    update_is_reset_clicked: (value) => dispatch(setIsResetClicked(value)),
    update_league: (value) => dispatch(setLeague(value)),
    set_default_sorting_option: (value) => dispatch(setSortType(value))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PlayerCard);
